import { Content } from '../../squidex';
const cloneDeep = require('lodash.clonedeep');


export class SchemaMetadataModel extends Content {
  constructor(current?: Content) {
    if (current) {
      super(cloneDeep(current));
    } else {
      super({});
    }
  }
}
